import React from 'react';
import SignInScreen from 'components/SignIn/SignInScreen';

const SignInSecurity = (): JSX.Element => <SignInScreen />;

export default SignInSecurity;
